// extracted by mini-css-extract-plugin
export default {"rating":"FA-z","numberOfStars":"GA-z","count":"HA-z","barGraphSpacing":"IA-z","barGraph":"JA-z"};